import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { useCustomerStore } from "~/stores/customer";
import { useNavigation } from "~/composables/use-navigation";
import { usePinia } from "#imports";

export default defineNuxtRouteMiddleware(() => {
  const pinia = usePinia();
  const customer = useCustomerStore(pinia);

  if (!customer.isLogged) {
    return;
  }

  const { resolvePath } = useNavigation();
  return navigateTo(resolvePath("my-account", {}), {
    replace: true,
  });
});
